<section id="about" class="py-5 bg-light" aria-label="Sobre o projeto SISMET">
  <div class="container">
    <h2 class="mb-4 text-center fw-bold">Sobre o Novo SISMET</h2>

    <div class="row justify-content-center">
      <div class="col-lg-10">
        <article appAnimateOnScroll class="card border-0 shadow-sm">
          <div class="card-body p-4 p-md-5">
            <p class="mb-4">
              O Novo SISMET (2026), constitui a evolução da plataforma SISMET,
              resultante do processo contínuo de amadurecimento tecnológico e
              científico de iniciativas previamente desenvolvidas no âmbito do
              monitoramento agrometeorológico e da aplicação estratégica de
              dados na cafeicultura. Essa nova etapa caracteriza-se por um
              avanço substancial, materializado em uma plataforma mais robusta,
              integrada e orientada ao suporte à tomada de decisão em distintos
              níveis de gestão, agregando tecnologia e inovação.
            </p>

            <p class="mb-4">
              O sistema foi desenvolvido no contexto de uma parceria entre a
              Cooxupé, o Polo EMBRAPII Agroindústria do Café, a Agrovantec e o
              IFSULDEMINAS, reunindo competências técnicas, científicas e
              institucionais com vistas à oferta de uma solução digital alinhada
              às demandas contemporâneas da cadeia produtiva do café.
            </p>

            <p class="mb-4">
              A plataforma integra dados provenientes de estações
              meteorológicas, pontos pluviométricos e análises agroclimáticas em
              um ambiente web de fácil acesso e elevada usabilidade,
              complementado por um aplicativo exclusivo destinado aos
              cooperados. O sistema apresenta abrangência espacial nas
              principais regiões cafeeiras atendidas pela Cooxupé, Sul de Minas,
              Mogiana Paulista, Cerrado Mineiro e as Matas de Minas.
            </p>

            <p class="mb-4">
              Dentre suas funcionalidades destacam-se o monitoramento
              agrometeorológico contínuo, geração de boletins técnicos,
              visualização e análise espacial de informações por meio de mapas
              temáticos, balanço hídrico, acompanhamento da dinâmica fenológica
              da cultura, com ênfase na evolução da florada, e a emissão de
              alertas climáticos.
            </p>

            <p class="mb-0">
              Destinado a gestores e cooperados, o Novo SISMET amplia o acesso à
              informação técnica qualificada e sistematizada, subsidia o
              planejamento agrícola e contribui para a antecipação de riscos
              climáticos, favorecendo a tomada de decisões mais assertivas. Com
              foco em inovação, eficiência operacional e usabilidade, a
              plataforma consolida-se como uma ferramenta estratégica para o
              fortalecimento da competitividade e da sustentabilidade da
              cafeicultura, promovendo a agregação de valor às atividades
              produtivas e apoiando o negócio do cooperado por meio da aplicação
              de soluções tecnológicas e inovadoras.
            </p>

            <!-- Seção de Parceiros -->
            <div class="mt-5">
              <h3 class="text-center fw-bold mb-4">Parceiros</h3>
              <div class="row g-4 align-items-center justify-content-center">
                <div class="col-6 col-md-3 text-center">
                  <img
                    src="assets/image/agrovantec.png"
                    alt="Agrovantec"
                    class="img-fluid partner-logo"
                  />
                </div>
                <div class="col-6 col-md-3 text-center">
                  <img
                    src="assets/image/embrapii.svg"
                    alt="EMBRAPII"
                    class="img-fluid partner-logo"
                  />
                </div>
                <div class="col-6 col-md-3 text-center">
                  <img
                    src="assets/image/embrapiiif.svg"
                    alt="Polo EMBRAPII Agroindústria do Café"
                    class="img-fluid partner-logo"
                  />
                </div>
                <div class="col-6 col-md-3 text-center">
                  <img
                    src="assets/image/if.svg"
                    alt="IFSULDEMINAS"
                    class="img-fluid partner-logo"
                  />
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</section>
